// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-2ea6fb23] {\n  list-style: none;\n}[dir] .item[data-v-2ea6fb23] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
